import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-baseline" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 0,
  class: "mt-6"
}
const _hoisted_5 = { class: "flex items-baseline" }
const _hoisted_6 = ["textContent"]
const _hoisted_7 = ["textContent"]
const _hoisted_8 = { class: "flex mt-1" }
const _hoisted_9 = {
  key: 1,
  class: "mt-6"
}
const _hoisted_10 = { class: "flex items-baseline" }
const _hoisted_11 = ["textContent"]
const _hoisted_12 = ["textContent"]
const _hoisted_13 = { class: "flex mt-1" }
const _hoisted_14 = {
  key: 2,
  class: "mt-6"
}
const _hoisted_15 = { class: "flex items-baseline" }
const _hoisted_16 = ["textContent"]
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "flex mt-1" }
const _hoisted_19 = { class: "flex items-center px-1 border rounded-lg shadow-inner dark:border-gray-700" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "px-2" }, " minutes ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_BalBtn = _resolveComponent("BalBtn")!
  const _component_BalTooltip = _resolveComponent("BalTooltip")!
  const _component_AppSlippageForm = _resolveComponent("AppSlippageForm")!
  const _component_BalBtnGroup = _resolveComponent("BalBtnGroup")!
  const _component_BalPopover = _resolveComponent("BalPopover")!

  return (_openBlock(), _createBlock(_component_BalPopover, { darkBgColor: "1000" }, {
    activator: _withCtx(() => [
      _createVNode(_component_BalBtn, {
        circle: "",
        color: _ctx.color,
        size: "sm",
        class: "mb-2 text-gray-500 icon-spin-anim",
        changeType: "trade",
        onClick: _ctx.onActivatorClick
      }, {
        default: _withCtx(() => [
          _createVNode(_component_BalIcon, {
            changeType: "setting",
            name: "settings",
            size: "sm"
          })
        ]),
        _: 1
      }, 8, ["color", "onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("span", {
            textContent: _toDisplayString(_ctx.$t('slippageTolerance')),
            class: "font-medium mb-2"
          }, null, 8, _hoisted_2),
          _createVNode(_component_BalTooltip, {
            bgColor: "dark:bg-gray-850",
            borderColor: "dark:border-custom-black-550"
          }, {
            activator: _withCtx(() => [
              _createVNode(_component_BalIcon, {
                name: "info",
                size: "xs",
                class: "ml-1 text-gray-400 -mb-px"
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", {
                innerHTML: _ctx.$t('marketConditionsWarning')
              }, null, 8, _hoisted_3)
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_AppSlippageForm, {
          class: "mt-1",
          changeType: 'trade'
        })
      ]),
      (!_ctx.hideLiquidity)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", {
                textContent: _toDisplayString(_ctx.$t('tradeLiquidity')),
                class: "font-medium mb-2"
              }, null, 8, _hoisted_6),
              _createVNode(_component_BalTooltip, null, {
                activator: _withCtx(() => [
                  _createVNode(_component_BalIcon, {
                    name: "info",
                    size: "xs",
                    class: "ml-1 text-gray-400 -mb-px"
                  })
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    textContent: _toDisplayString(_ctx.$t('whichPools'))
                  }, null, 8, _hoisted_7)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_BalBtnGroup, {
                options: _ctx.tradeLiquidityOptions,
                modelValue: _ctx.appTradeLiquidity,
                "onUpdate:modelValue": [
                  _cache[0] || (_cache[0] = ($event: any) => (_ctx.appTradeLiquidity = $event)),
                  _ctx.setTradeLiquidity
                ]
              }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isEIP1559SupportedNetwork)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", {
                textContent: _toDisplayString(_ctx.$t('transactionType')),
                class: "font-medium mb-2"
              }, null, 8, _hoisted_11),
              _createVNode(_component_BalTooltip, null, {
                activator: _withCtx(() => [
                  _createVNode(_component_BalIcon, {
                    name: "info",
                    size: "xs",
                    class: "ml-1 text-gray-400 -mb-px"
                  })
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    textContent: _toDisplayString(_ctx.$t('ethereumTxTypeTooltip'))
                  }, null, 8, _hoisted_12)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_BalBtnGroup, {
                options: _ctx.ethereumTxTypeOptions,
                modelValue: _ctx.ethereumTxType,
                "onUpdate:modelValue": [
                  _cache[1] || (_cache[1] = ($event: any) => (_ctx.ethereumTxType = $event)),
                  _ctx.setEthereumTxType
                ]
              }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isGassless && _ctx.context === _ctx.TradeSettingsContext.trade)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("span", {
                textContent: _toDisplayString(_ctx.$t('transactionDeadline')),
                class: "font-medium mb-2"
              }, null, 8, _hoisted_16),
              _createVNode(_component_BalTooltip, null, {
                activator: _withCtx(() => [
                  _createVNode(_component_BalIcon, {
                    name: "info",
                    size: "xs",
                    class: "ml-1 text-gray-400 -mb-px"
                  })
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    innerHTML: _ctx.$t('transactionDeadlineTooltip')
                  }, null, 8, _hoisted_17)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _withDirectives(_createElementVNode("input", {
                  class: "w-8 text-right bg-transparent",
                  "onUpdate:modelValue": [
                    _cache[2] || (_cache[2] = ($event: any) => (_ctx.appTransactionDeadline = $event)),
                    _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.setTransactionDeadline && _ctx.setTransactionDeadline(...args)))
                  ],
                  placeholder: "20",
                  type: "number",
                  step: "1",
                  min: "0"
                }, null, 512), [
                  [_vModelText, _ctx.appTransactionDeadline]
                ])
              ]),
              _hoisted_20
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}